import React from 'react';
import {Box, FormControl, Input as InputNative} from 'native-base';
import {message} from '../../../utils/messages';
import {defaultProps} from '../constants';

export const ReadonlyInput = ({
  value,
  label,
  icon,
  width,
  backgroundColor,
}: {
  value: string;
  label: string;
  icon?: any;
  width?: string;
  backgroundColor?: string;
}) => {
  const InternalIcon = () => <Box marginLeft={5}>{icon}</Box>;

  return (
    <Box width={width ?? '100%'} marginBottom={5}>
      <FormControl>
        <FormControl.Label>{message(label)}</FormControl.Label>
        <InputNative
          InputLeftElement={icon ? <InternalIcon /> : <></>}
          {...defaultProps}
          backgroundColor={'white'}
          value={value}
          isReadOnly={true}
          _input={{
            color: '#858597',
            backgroundColor,
          }}
        />
      </FormControl>
    </Box>
  );
};
